import { Card } from '@magicschool/spellbook/components/Card';
import { Slot } from '@magicschool/spellbook/components/Slot';
import { cn } from '@magicschool/spellbook/lib/utils';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';

export const HoverCardTriggerSlot = Slot<React.ComponentProps<typeof HoverCardPrimitive.Trigger>>({
  displayName: 'HoverCard.Trigger',
  preventOverride: true,
  renderDefault: ({ ...props }) => {
    return <HoverCardPrimitive.Trigger data-spellbook-name="hover-card-trigger" {...props} />;
  },
});

export const HoverCardContentSlot = Slot<React.ComponentProps<typeof HoverCardPrimitive.Content>>({
  displayName: 'HoverCard.Content',
  preventOverride: true,
  renderDefault: ({ children, className, align = 'center', sideOffset = 4, ...props }) => {
    return (
      <HoverCardPrimitive.Portal data-spellbook-name="hover-card-portal">
        <HoverCardPrimitive.Content
          data-spellbook-name="hover-card-content"
          align={align}
          asChild
          sideOffset={sideOffset}
          className={cn(
            [
              'data-[state=open]:animate-in',
              'data-[state=closed]:animate-out',
              'data-[state=closed]:fade-out-0',
              'data-[state=open]:fade-in-0',
              'data-[state=closed]:zoom-out-95',
              'data-[state=open]:zoom-in-95',
              'data-[side=bottom]:slide-in-from-top-2',
              'data-[side=left]:slide-in-from-right-2',
              'data-[side=right]:slide-in-from-left-2',
              'data-[side=top]:slide-in-from-bottom-2',
              'z-portal',
              'origin-(--radix-hover-card-content-transform-origin)',
              'shadow-popover',
              'outline-hidden',
              'border',
              'border-border-default',
              'rounded-card-md',
            ],
            className,
          )}
          {...props}
        >
          <Card>
            <Card.Content>{children}</Card.Content>
          </Card>
        </HoverCardPrimitive.Content>
      </HoverCardPrimitive.Portal>
    );
  },
});
